import React from 'react';
import { names } from '../../../core/common/selectoption/selectoption';
import { Select } from 'antd';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';

const GuardianModal = () => {
  const routes = all_routes;
  const getModalContainer = () => {
    const modalElement = document.getElementById('modal-tag');
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  const getModalContainer2 = () => {
    const modalElement = document.getElementById('modal-tag2');
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  return (
    <>
      {/* Add Parent */}
      <div className='modal fade' id='add_guardian'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Add Guardian</h4>
              <button
                type='button'
                className='btn-close custom-btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='ti ti-x' />
              </button>
            </div>
            <form>
              <div id='modal-tag2' className='modal-body'>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className='d-flex align-items-center upload-pic flex-wrap row-gap-3 mb-3'>
                      <div className='d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames'>
                        <i className='ti ti-photo-plus fs-16' />
                      </div>
                      <div className='profile-upload'>
                        <div className='profile-uploader d-flex align-items-center'>
                          <div className='drag-upload-btn mb-3'>
                            Upload
                            <input
                              type='file'
                              className='form-control image-sign'
                              multiple
                            />
                          </div>
                          <Link to='#' className='btn btn-primary mb-3'>
                            Remove
                          </Link>
                        </div>
                        <p>Upload image size 4MB, Format JPG, PNG, SVG</p>
                      </div>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Name</label>
                      <input type='text' className='form-control' />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Phone Number</label>
                      <input type='text' className='form-control' />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Email Address</label>
                      <input type='text' className='form-control' />
                    </div>
                    <div className='mb-0'>
                      <label className='form-label'>Child</label>

                      <Select
                        mode='multiple'
                        allowClear
                        className='select'
                        getPopupContainer={getModalContainer2}
                        style={{ width: '100%' }}
                        placeholder='Please select'
                        defaultValue={[]}
                        options={names}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='modal-footer'>
                <Link
                  to='#'
                  className='btn btn-light me-2'
                  data-bs-dismiss='modal'
                >
                  Cancel
                </Link>
                <Link
                  to='#'
                  data-bs-dismiss='modal'
                  className='btn btn-primary'
                >
                  Add Guardian
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Parent */}
      {/* Edit Parent */}
      <div className='modal fade' id='edit_guardian'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Edit Guardian</h4>
              <button
                type='button'
                className='btn-close custom-btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='ti ti-x' />
              </button>
            </div>
            <form>
              <div id='modal-tag' className='modal-body '>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className='d-flex align-items-center upload-pic flex-wrap row-gap-3 mb-3'>
                      <div className='d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames'>
                        <i className='ti ti-photo-plus fs-16' />
                      </div>
                      <div className='profile-upload'>
                        <div className='profile-uploader d-flex align-items-center'>
                          <div className='drag-upload-btn mb-3'>
                            Upload
                            <input
                              type='file'
                              className='form-control image-sign'
                              multiple
                            />
                          </div>
                          <Link to='#' className='btn btn-primary mb-3'>
                            Remove
                          </Link>
                        </div>
                        <p>Upload image size 4MB, Format JPG, PNG, SVG</p>
                      </div>
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Name</label>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Enter Name'
                        defaultValue='Thomas'
                      />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Phone Number</label>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Enter Phone Number'
                        defaultValue='+1 65738 58937'
                      />
                    </div>
                    <div className='mb-3'>
                      <label className='form-label'>Email Address</label>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Enter Email Address'
                        defaultValue='thomas@example.com'
                      />
                    </div>
                    <div className='mb-0'>
                      <label className='form-label'>Child</label>

                      <Select
                        mode='multiple'
                        allowClear
                        className='select'
                        getPopupContainer={getModalContainer}
                        style={{ width: '100%' }}
                        placeholder='Please select'
                        defaultValue={['Tim', 'Jammy']}
                        options={names}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='modal-footer'>
                <Link
                  to='#'
                  className='btn btn-light me-2'
                  data-bs-dismiss='modal'
                >
                  Cancel
                </Link>
                <Link to='#' className='btn btn-primary'>
                  Save Changes
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Edit Parent */}

      {/* Delete Modal */}
      <div className='modal fade' id='delete-modal'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <form>
              <div className='modal-body text-center'>
                <span className='delete-icon'>
                  <i className='ti ti-trash-x' />
                </span>
                <h4>Confirm Deletion</h4>
                <p>
                  You want to delete all the marked items, this cant be undone
                  once you delete.
                </p>
                <div className='d-flex justify-content-center'>
                  <Link
                    to='#'
                    className='btn btn-light me-3'
                    data-bs-dismiss='modal'
                  >
                    Cancel
                  </Link>
                  <Link
                    to='#'
                    className='btn btn-danger'
                    data-bs-dismiss='modal'
                  >
                    Yes, Delete
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Delete Modal */}
    </>
  );
};

export default GuardianModal;
